import { LINK_STATUS } from '../constants';

export const isPublishable = (link) => {
  return (
    link.status === LINK_STATUS.DRAFT || link.status === LINK_STATUS.SCHEDULED
  );
};

export const isSchedulable = (link) => {
  return (
    link.status === LINK_STATUS.DRAFT || link.status === LINK_STATUS.SCHEDULED
  );
};

export const isDeletable = (link) => {
  return (
    link.status === LINK_STATUS.DRAFT || link.status === LINK_STATUS.SCHEDULED
  );
};

export const isArchivable = (link) => {
  return link.status === LINK_STATUS.PUBLISHED;
};

export const isDeletableFromArchive = (link) => {
  return link.status === LINK_STATUS.ARCHIVED;
};
